export const ID_CHECKIN = 'CHECKIN';//return
export  const ID_CHECKOUT = 'CHECKOUT';//exit